<template lang="pug">
div
  app-divider(:label="titulo")
  el-row(:gutter="30")
    el-col(:span="6")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Número")
        app-label(label="Matrícula:", :required="true")
        el-input.input(
          v-model="imovel.numeroMatricula",
          name='Matrícula',
          maxlength="50",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','numeroMatricula')"
        )
        span.help.erro {{ errors[0] }}
    el-col.inputDiv(:span="8")
      validation-provider(v-slot="{ errors }", name="Imóvel/nomeCartorio")
        app-label(label="Nome do cartório:", :required="false")
        el-input.input(
          v-model="imovel.nomeCartorio",
          name="nomeCartorio",
          maxlength="300"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','nomeCartorio')"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(v-slot="{ errors }", name="Imóvel/Livro")
        app-label(label="Livro:", :required="false")
        el-input.input(
          v-model="imovel.livroMatricula",
          name='Livro',
          maxlength="50"
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','livroMatricula')"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(v-slot="{ errors }", name="Imóvel/folha")
        app-label(label="Folha:", :required="false")
        el-input.input(
          v-model="imovel.numeroFolhaMatricula",
          name='folha',
          maxlength="50",
          :class="{'erro' : errors.length}"
          @input="toUppercase($event, 'imovel','numeroFolhaMatricula')"
        )
        span.help.erro {{ errors[0] }}
    el-col(:span="6")
      validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Município do cartório")
        app-label( label="Município do cartório:", :required="true")
        el-select.input(
          style="display: block"
          class="select",
          v-model="imovel.municipioCartorio",
          no-match-text="Nenhum Município Encontrado",
          placeholder="Selecione",
          filterable,
          clearable,
          @clear="imovel.municipioCartorio = null"
          value-key="id",
          name="Município do cartório",
          :class="{'erro' : errors.length}"
        )
          el-option(
            v-for="item in municipios",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
        span.help.erro {{ errors[0] }}
</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppDivider,
    AppLabel
  },
  data () {
    return {
      municipios: []
    }
  },
  props: {
    imovel: {
      required: true
    },
    titulo: {
      type: String,
      required: false,
      default: 'Matrícula'
    }
  },

  created () {
    this.getMunicipiosByUf()
  },

  methods: {
    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
      this.municipios.forEach(element => {
        element.nome = element.nome.toUpperCase()
      })
    },
    toUppercase (valor, primeiro, segundo) {
      this[primeiro][segundo] = valor.toUpperCase()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}

.full-width {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/processoFisico/components/MatriculaTituloImovel.vue